module.exports = __webpack_public_path__ + "static/media/key-kession-icon.c7857633.png";